/* eslint-disable max-len */
export const vehicleAccommodationOptions = [
	{
		value: 'Outdoor-uncovered',
		label: 'Outdoor-uncovered'
	},
	{
		value: 'Outdoor-covered',
		label: 'Outdoor-covered'
	},
	{
		value: 'Indoor',
		label: 'Indoor'
	},
	{
		value: 'Available for enclosed vehicle storage',
		label: 'Enclosed'
	}
];

export const vehicleStackedUnitBuckets = [
	'enclosed',
	'outdoorCovered',
	'outdoorUncovered',
	'indoor'
];

export const storageStackedUnitBuckets = [
	'smallUnit',
	'mediumUnit',
	'largeUnit'
];

export const unitSizeOptions = [{
	title: "5' x 5'",
	sqft: 25,
	looksLike: 'Hall closet or half bathroom',
	whatFits: 'Small items, like bags, suitcases and boxes',
	search: '0-25'
}, {
	title: "5' x 10'",
	sqft: 50,
	looksLike: 'Large walk-in closet',
	whatFits: 'The contents of an average studio apartment',
	search: '26-60'
}, {
	title: "5' x 15'",
	sqft: 75,
	looksLike: 'Small bedroom',
	whatFits: 'The contents of a small one-bedroom apartment',
	search: '61-75'
}, {
	title: "10' x 10'",
	sqft: 100,
	looksLike: 'Average bedroom',
	whatFits: 'The contents of a one-bedroom apartment',
	search: '76-100'
}, {
	title: "10' x 15'",
	sqft: 150,
	looksLike: 'Small one-car garage',
	whatFits: 'The contents of a two-bedroom house or large apartment',
	search: '101-150'
}, {
	title: "10' x 20'",
	sqft: 200,
	looksLike: 'Standard one-car garage',
	whatFits: 'The contents of a two- to three-bedroom house or full garage',
	search: '151-200'
}, {
	title: "10' x 25'",
	sqft: 250,
	looksLike: 'One-car garage',
	whatFits: 'The contents of a three-bedroom house',
	search: '201-250'
}, {
	title: "10' x 30'",
	sqft: 300,
	looksLike: 'Two-car garage',
	whatFits: 'Four to five bedroom house with appliances or a 40 ft. moving van',
	search: '251-300'
}];

export const vehicleUnitSizeOptions = [{
	title: "15' Long",
	description: 'Most coupes, hatchbacks, crossovers and small SUVs that come under 15 feet in length will fit. If you choose this size, you might be left with only a few inches of space.'
}, {
	title: "20' Long",
	description: 'Most cars will fit comfortably, including SUVs, crossovers, sedans, minivans, pickup trucks and most full-sized vans.'
}, {
	title: "25' Long",
	description: 'Perfect for larger vehicles or a boat. Small Class B campers, small Class C campers, travel trailers, toy trailers and pop-ups may also fit in spaces designed for RV storage.'
}, {
	title: "30' Long",
	description: 'Store one or multiple vehicles with plenty of other possessions, including furniture and large appliances. This size can also handle smaller-to-medium sized Class B campers and travel trailers, large pop-ups, and smaller Class C campers and fifth-wheel trailers.'
}, {
	title: "35' Long",
	description: 'Store one or multiple vehicles with plenty of other possessions, including furniture and large appliances. This size can typically contain large Class B and Class C campers, mid-to-large sized travel trailers, small-to-mid sized fifth-wheel campers, large toy trailers, and small Class A campers.'
}, {
	title: "40' Long",
	description: "All but the largest of RVs will fit into a 40' storage space. This includes most Class A campers, large travel trailers and fifth-wheel trailers. Remember that with the added length often comes additional width and height, meaning that many of these extra-large vehicles will require ceilings with a minimum height of 15 feet."
}, {
	title: "50' Long",
	description: "50' RV storage space will handle the largest of RVs, like large Class A campers, travel trailers and destination trailers. Remember that with the added length often comes additional width and height, meaning that many of these extra-large vehicles will require ceilings with a minimum height of 15 feet."
}];

export const vehicleAccommodationDescriptions = [{
	title: 'Outdoor Uncovered Unit',
	description: 'A Vehicle Parking Space is exactly what it sounds like: an area for you to park your vehicle. The parking area may be paved or on a variety of unpaved surfaces including gravel, dirt, or an open field on the storage facility’s grounds.'
}, {
	title: 'Outdoor Covered Unit',
	description: 'With Covered vehicle storage, you’ll typically park your vehicle under a standalone roof alongside other vehicles, though some covered units do have three walls separating your vehicle from the rest. Though you won’t get as much protection as from an enclosed unit or indoor, the roof structure will protect your vehicle from the harshest elements.'
}, {
	title: 'Indoor Unit',
	description: 'With Indoor vehicle storage, your vehicle will be parked inside a large structure such as a warehouse with other vehicles. Indoor vehicle storage provides the same protection from the elements as enclosed storage, but since your vehicle will be in a shared space there may be different access requirements.'
}, {
	title: 'Enclosed Unit',
	description: 'Enclosed Vehicle Storage is the safest and most secure means of storing your vehicle. These are large self-storage units that essentially act as garages you can drive your vehicle straight into, and are accessed via a large roll-up door. Enclosed units provide protection from winter weather and prevent any unwanted access to your vehicle.'
}];

export const unitAmenityOptions = [{
	title: 'Climate Control',
	details: 'The facility will maintain a safe temperature and humidity level for your unit. ' +
		'If you’re storing something temperature-sensitive or particularly valuable, climate control is a good idea.',
	amenity: 'climateControlled'
}, {
	title: 'Drive-Up Access',
	details: 'You can pull your moving truck or vehicle right up to the unit. ' +
		'This is rarely available for indoor units.',
	amenity: 'driveUpAccess'
}, {
	title: 'Truck Rental',
	details: 'Some facilities will let you rent their moving truck for free. Specific terms and restrictions ' +
		'will vary by facility (e.g., mileage limits, time limits, insurance requirements, refueling protocol)',
	amenity: 'truckRental'
}, {
	title: '24-Hour Access',
	details: 'You have access to your unit at any time. Restrictions may apply—for example, ' +
		'your facility could require manager approval. Some facilities only allow business ' +
		'customers 24-hour access or may charge additional fees.',
	amenity: 'twentyFourHours'
}, {
	title: 'Locks',
	details: 'Most facilities require you to bring your own lock, although many will sell locks onsite. ' +
		'We recommend closed-shackle padlocks, disc locks or cylinder locks. ' +
		'Standard or combination padlocks are easily picked and not recommended.',
	amenity: 'locks'
}, {
	title: 'Security',
	details: 'Video camera surveillance, electronic gates and “fenced + lighted” can all ' +
		'increase the security of the facility. A manager who lives onsite means that someone ' +
		'will be on the premises during non-business hours.',
	amenity: 'security'
}];
